<template lang="pug">
.no-use-container(v-if="show")
  .shadow(@click="closeModal")
  .no-use
    .no-use-top
      img.no-use-close(src="https://m.hellobike.com/resource/gallery/61/jnlkOWH5wR.png?x-oss-process=image/quality,q_80" @click="closeModal")
      .no-use-line
        .no-use-line-left
          .no-use-line-left-img
            img.no-use-title-img(src="https://m.hellobike.com/resource/gallery/61/_z0qYULOF3.png?x-oss-process=image/quality,q_80")
          .no-use-line-left-word
            span 30天内
            span.red-word 仅可退1次
            span ,仅可退最近开通周期会员
        .no-use-line-right
          img(src="https://m.hellobike.com/resource/gallery/61/ZqhDNJ8apD.png?x-oss-process=image/quality,q_80")
      .no-use-btn
        .no-use-left(@click="goRefund") 我要退款
        .no-use-right(@click="closeModal") 我已知晓
    .no-use-bottom
</template>
<script>
import { UBT } from '@hb/tianqi/lib/ubt.h5';

export default {
  components: {
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    };
  },
  destroyed() {
  },
  created() {
  },
  methods: {
    goRefund() {
      UBT.clickButton({
        pageId: 'platform_openedcard_page',
        buttonName: 'platform_Confirm_refund',
        categoryId: 'platform',
        businessInfo: {},
      });
      this.$emit('showRefundBlock', true);
      this.$emit('update:show', false);
    },
    closeModal() {
      this.$emit('update:show', false);
    },
  },
};
</script>
<style lang="less" scoped>
.no-use-container {
  position: fixed;
  bottom: 0;
  z-index: 222;
  width: 100%;

  .no-use {
    background: linear-gradient(180deg, #fff9e5 0%, #fff 100%);
    box-shadow: 0 0.01rem 0.05rem 0 rgba(255, 255, 255, 0.27);
    border-radius: 0.24rem 0.24rem 0 0;
    position: relative;
    z-index: 223;
    height: 2.21rem;

    .no-use-top {
      img.no-use-close {
        position: absolute;
        top: 0.26rem;
        right: 0.16rem;
        height: 0.16rem;
        width: 0.16rem;
      }

      .no-use-line {
        display: flex;
        justify-content: space-between;
        padding: 0.38rem 0.43rem 0 0.25rem;

        .no-use-line-left {
          .no-use-line-left-img {
            width: 1.68rem;
            height: 0.25rem;

            img.no-use-title-img {
              width: 1.68rem;
              height: 0.25rem;
            }
          }

          .no-use-line-left-word {
            margin-top: 0.07rem;
            font-family: PingFangSC, PingFang SC, sans-serif;
            ;
            font-weight: 400;
            font-size: 0.14rem;
            color: #242729;

            span.red-word {
              color: #ff5526;
            }
          }
        }

        .no-use-line-right {
          margin-top: -0.02rem;
          img {
            width: 0.58rem;
            height: 0.6rem;
          }
        }
      }

      .no-use-btn {
        display: flex;
        justify-content: space-around;
        margin-top: 0.39rem;
        padding: 0 0.2rem;
        text-align: center;

        .no-use-left {
          width: 1.68rem;
          height: 0.48rem;
          background: #f3f3f4;
          border-radius: 0.08rem;
          font-family: PingFangSC, PingFang SC, sans-serif;
          font-weight: 500;
          font-size: 0.18rem;
          color: #242729;
          line-height: 0.48rem;
        }

        .no-use-right {
          width: 1.59rem;
          height: 0.48rem;
          border-radius: 0.08rem;
          background: linear-gradient(90deg, #fa8621 0%, #fa3a00 100%);
          font-family: PingFangSC, PingFang SC, sans-serif;
          font-weight: 500;
          font-size: 0.18rem;
          color: #fff;
          line-height: 0.48rem;
        }
      }
    }
  }

  .shadow {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: #000;
    opacity: 0.7;
    z-index: 100;
  }
}
</style>
